<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
            <ValidationObserver ref="form" v-slot="{ invalid }">
                <v-card-title class="justify-center card_titulo mx-9">
                    <div class="headerModal">
                        <img src="/static/modal/empleadoBaja.svg" class="imgModal" />
                        <h2 class="titleModal">Descargar reporte de empleados de baja</h2>
                    </div>
                </v-card-title>

                <v-card-text class="card_texto">
                    <v-col cols="12" xs="12" sm="12" md="12" class="pa-0 d-flex justify-center" v-if="isLoading">
                        <v-progress-circular
                            indeterminate
                            :size="100"
                            :width="7"
                            color="blue"
                        ></v-progress-circular>
                    </v-col>

                    <v-container v-if="!isLoading" grid-list-md class="pt-5">
                        <v-row>
                            <template v-if="rol == 'root'">
                                <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                    <ValidationProvider v-slot="{ errors }" name="Cliente" rules="required">
                                        <v-autocomplete
                                            outlined
                                            :items="clientes"
                                            item-text="nombre"
                                            item-value="id"
                                            label="Cliente"
                                            persistent-hint
                                            v-model="cliente_id"
                                            :error-messages="errors"
                                        ></v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                            </template>

                            <template v-if="rol == 'root' || rol == 'admin'">
                                <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="empresas"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Empresa"
                                        persistent-hint
                                        v-model="empresa_id"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'">
                                <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="sucursales"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Sucursal"
                                        persistent-hint
                                        v-model="sucursal_id"
                                    ></v-autocomplete>
                                </v-col>
                            </template>
                            <v-col cols="12" xs="12" sm="12" md="12" class="pt-0 pb-0 ma-0">
                                <v-autocomplete
                                    outlined
                                    label="Registro Patronal"
                                    :items="registroPatronal"
                                    item-text="nombreClave"
                                    item-value="id"
                                    persistent-hint
                                    v-model="registro_patronal_id"
                                    class="pa-0 ma-0"
                                >
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    v-model="fecha_baja_min"
                                    :valorDefecto="fecha_baja_min"
                                    label="Fecha mínima de baja"
                                    placeholder="dd/mm/aaaa"
                                    ref="FechaBajaMin"
                                />
                            </v-col>

                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    v-model="fecha_baja_max"
                                    :valorDefecto="fecha_baja_max"
                                    label="Fecha máxima de baja"
                                    placeholder="dd/mm/aaaa"
                                    ref="FechaBajaMax"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions class="d-flex justify-end card_accion">
                    <button
                        class="btnCerrar"
                        @click="cerrar()"
                        :disabled="isDownloading"
                    >
                        Cancelar
                    </button>
                    <v-btn
                        class="btnGuardar"
                        @click="descargar()"
                        :disabled="invalid"
                        :loading="isDownloading"
                    >
                        Descargar
                    </v-btn>
                </v-card-actions>
            </ValidationObserver>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import FileDownload from 'js-file-download';
import Notify from '@/plugins/notify';
import VuetifyDatePicker from '@/components/VuetifyDatePicker.vue';
import clientesApi from '@/api/clientes';
import empresaApi from '@/api/empresas';
import sucursalApi from '@/api/sucursales';
import apiRegistroPatronal from "@/api/nominas/registroPatronal";

export default {
    name: 'modalReporteEmpleadosBaja',
    components: {
        VuetifyDatePicker
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        datosLogin: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            dialog: false,
            isLoading: false,
            isDownloading: false,
            rol: '',
            clientes: [],
            empresas: [],
            sucursales: [],
            registroPatronal: [],
            cliente_id: null,
            empresa_id: null,
            sucursal_id: null,
            registro_patronal_id: null,
            fecha_baja_min: null,
            fecha_baja_max: null
        };
    },
    watch: {
        value(val) {
            this.dialog = val;
            if (val) {
                this.inicializar();
            }
        },
        dialog(val) {
            this.$emit('input', val);
        },
        cliente_id(val) {
            if (val != null) {
                this.cambiaCliente(val);
                this.getRegistroPatronal(val);
            }
        },
        empresa_id(val) {
            if (val != null) {
                this.cambiaEmpresa(val);
            }
        }
    },
    methods: {
        inicializar() {
            this.rol = this.datosLogin.rol.name;
            this.resetValues();
            this.loadInitialData();
            console.log(this.datosLogin);
        },
        loadInitialData() {
            this.isLoading = true;

            if (this.rol == 'root') {
                this.getClientes();
            } else if (this.rol == 'admin') {
                this.cliente_id = this.datosLogin.cliente_id;
                this.cambiaCliente(this.datosLogin.cliente_id);
            } else if (this.rol == 'admin-empresa') {
                this.cliente_id = this.datosLogin.cliente_id;
                this.empresa_id = this.datosLogin.empresa_id;
                this.cambiaEmpresa(this.datosLogin.empresa_id);
            } else if (this.rol == 'admin-sucursal') {
                this.cliente_id = this.datosLogin.cliente_id;
                this.empresa_id = this.datosLogin.empresa_id;
                this.sucursal_id = this.datosLogin.sucursal_id;
                this.isLoading = false;
            }
            else {
                this.cliente_id = this.datosLogin.cliente_id;
                this.empresa_id = this.datosLogin.empresa_id;
                this.sucursal_id = this.datosLogin.sucursal_id;
                this.isLoading = false;
            }
        },
        getClientes() {
            let param = { activo: true, paginate: false };
            clientesApi.getClientes(param)
                .then((response) => {
                    this.clientes = response.data;
                    this.isLoading = false;
                })
                .catch((err) => {
                    console.error(err);
                    Notify.ErrorToast('Ocurrió un error al cargar los clientes.');
                    this.isLoading = false;
                });
        },
        cambiaCliente(cliente) {
            this.empresa_id = null;
            this.sucursal_id = null;
            this.empresas = [];
            this.sucursales = [];

            let param = { activo: true, paginate: false, cliente_id: cliente };
            empresaApi.getEmpresas(param)
                .then((response) => {
                    this.empresas = response.data;
                    this.isLoading = false;
                })
                .catch((err) => {
                    console.error(err);
                    Notify.ErrorToast('Ocurrió un error al cargar las empresas.');
                    this.isLoading = false;
                });
        },
        async getRegistroPatronal(cliente){
            this.registro_patronal_id = null;
            this.registroPatronal = [];
            let parametros = { activo:true, paginate:false, order:"asc", cliente_id: cliente };
            await apiRegistroPatronal.find(parametros).then((response) => {
                let format = response.data;
                if(response.data.length != 0){
                    format.forEach( item => {
                        item.nombreClave = item.nombre + ' - ' + item.clave
                        this.registroPatronal.push(item);
                    })
                }
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los Registros Patronales.");
            });
        },
        cambiaEmpresa(empresa) {
            this.sucursal_id = null;
            this.sucursales = [];

            let parametros = { activo: true, paginate: false, empresa_id: empresa };
            sucursalApi.getSucursales(parametros)
                .then((response) => {
                    this.sucursales = response.data;
                    this.isLoading = false;
                })
                .catch((err) => {
                    console.error(err);
                    Notify.ErrorToast('Ocurrió un error al cargar las sucursales.');
                    this.isLoading = false;
                });
        },
        descargar() {
            let self = this;

            this.$refs.form.validate().then(success => {
                if (!success) {
                    return;
                }

                self.isDownloading = true;

                let parametros = {
                    cliente_id: self.cliente_id,
                    empresa_id: self.empresa_id,
                    sucursal_id: self.sucursal_id,
                    registro_patronal_id: self.registro_patronal_id,
                    min_fecha_baja: self.fecha_baja_min,
                    max_fecha_baja: self.fecha_baja_max,
                    rol: self.rol,
                    usuario_id: self.datosLogin.id
                };

                let path = 'empleados/exportar-baja';
                let nombre_archivo = 'reporte_empleados_baja.xlsx';

                try {
                    axios({
                        method: "get",
                        url: path,
                        responseType: 'blob',
                        params: parametros
                    }).then(resp => {
                        if (resp.status == 200) {
                            FileDownload(resp.data, nombre_archivo);
                            Notify.SuccessToast("Descarga realizada.");
                            self.cerrar();
                        }
                        self.isDownloading = false;
                    }).catch((err) => {
                        Notify.ErrorToast('No se pudo descargar el archivo.');
                        console.log(err.response);
                        self.isDownloading = false;
                    });
                } catch (error) {
                    Notify.ErrorToast('No se pudo descargar el archivo.');
                    console.log(error);
                    self.isDownloading = false;
                }
            });
        },
        cerrar() {
            this.dialog = false;
            this.resetValues();
        },
        resetValues() {
            this.clientes = [];
            this.empresas = [];
            this.sucursales = [];
            this.cliente_id = null;
            this.empresa_id = null;
            this.sucursal_id = null;
            this.registro_patronal_id = null;
            this.fecha_baja_min = null;
            this.fecha_baja_max = null;

            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                }
                if (this.$refs.FechaBajaMin) {
                    this.$refs.FechaBajaMin.resetDate();
                }
                if (this.$refs.FechaBajaMax) {
                    this.$refs.FechaBajaMax.resetDate();
                }
            });
        },
        validarFecha(valorFecha) {
            try {
                let fecha = valorFecha.split('-');
                let dia = fecha[2];
                let mes = fecha[1];
                let ano = fecha[0];
                let estado = true;
                let dmax = 0;
                let diaC = null;
                let mesC = null;
                let anoC = null;

                if ((dia.length == 2) && (mes.length == 2) && (ano.length == 4)) {
                    switch (parseInt(mes)) {
                        case 1: dmax = 31; break;
                        case 2:
                            if (((ano % 4 == 0) && (ano % 100 != 0)) || (ano % 400 == 0))
                                dmax = 29;
                            else
                                dmax = 28;
                            break;
                        case 3: dmax = 31; break;
                        case 4: dmax = 30; break;
                        case 5: dmax = 31; break;
                        case 6: dmax = 30; break;
                        case 7: dmax = 31; break;
                        case 8: dmax = 31; break;
                        case 9: dmax = 30; break;
                        case 10: dmax = 31; break;
                        case 11: dmax = 30; break;
                        case 12: dmax = 31; break;
                    }

                    dmax != "" ? dmax : dmax = -1;

                    if ((dia >= 1) && (dia <= dmax) && (mes >= 1) && (mes <= 12)) {
                        let i = 0;
                        for (i = 0; i < fecha[2].length; i++) {
                            diaC = fecha[2].charAt(i).charCodeAt(0);
                            (!((diaC > 47) && (diaC < 58))) ? estado = false : '';
                            mesC = fecha[1].charAt(i).charCodeAt(0);
                            (!((mesC > 47) && (mesC < 58))) ? estado = false : '';
                        }
                    } else {
                        estado = false;
                    }

                    let j = 0;
                    for (j = 0; j < fecha[0].length; j++) {
                        anoC = fecha[0].charAt(j).charCodeAt(0);
                        (!((anoC > 47) && (anoC < 58))) ? estado = false : '';
                    }
                } else {
                    estado = false;
                }
                return estado;
            } catch (err) {
                return false;
            }
        }
    }
};
</script>

<style scoped>
.divider {
    margin-bottom: 16px;
}
</style>
